"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var MotionShortcut = (function (_super) {
    __extends(MotionShortcut, _super);
    function MotionShortcut() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasPreviewTelemetryBeenFired = false;
        _this.handleAnimationOptionChange = function (animationOption) {
            var blockStore = _this.props.blockStore;
            var blockStyleStore = blockStore.blockStyleStore;
            var animation = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("animation"));
            animation.animationOption = animationOption;
            blockStyleStore.setElementStyle("animation", animation);
            _this.preview();
            _this.trackOnly("Block Styles Animation Changed", {
                block_styles_animation_option: animationOption,
            });
        };
        _this.handleAnimationTypeChange = function (animationType) {
            var blockStore = _this.props.blockStore;
            var blockStyleStore = blockStore.blockStyleStore;
            var animation = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("animation"));
            animation.animationType = animationType;
            blockStyleStore.setElementStyle("animation", animation);
            _this.preview();
            _this.trackOnly("Block Styles Animation Changed", {
                block_styles_animation_type: animationType,
            });
        };
        _this.handleDirectionChange = function (direction) {
            var blockStore = _this.props.blockStore;
            var blockStyleStore = blockStore.blockStyleStore;
            var animation = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("animation"));
            animation.direction = direction;
            blockStyleStore.setElementStyle("animation", animation);
            _this.preview();
            _this.trackOnly("Block Styles Animation Changed", {
                block_styles_animation_direction: direction,
            });
        };
        _this.handleSpeedChange = function (speed) {
            var blockStore = _this.props.blockStore;
            var blockStyleStore = blockStore.blockStyleStore;
            var animation = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("animation"));
            animation.speed = speed;
            blockStyleStore.setElementStyle("animation", animation);
            _this.preview();
            _this.trackOnly("Block Styles Animation Changed", {
                block_styles_animation_speed: speed,
            });
        };
        _this.handlePreviewClick = function () {
            if (!_this.hasPreviewTelemetryBeenFired) {
                _this.trackOnly("Block Styles Animation Previewed");
                _this.hasPreviewTelemetryBeenFired = true;
            }
            _this.preview();
        };
        _this.preview = function () {
            _this.props.blockStore.previewAnimation();
        };
        _this.trackOnly = function (name, parameters) {
            _this.props.telemetry.trackOnly(name, parameters || {}, {
                blockIntercom: true,
            });
        };
        return _this;
    }
    MotionShortcut.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderAnimationOptions(),
            this.renderAnimationType(),
            this.renderDirection(),
            this.renderSpeed(),
            this.renderPreviewButton()));
    };
    MotionShortcut.prototype.componentDidMount = function () {
        this.trackOnly("Block Styles Animation Viewed");
    };
    MotionShortcut.prototype.componentWillUnmount = function () {
        this.props.blockStore.turnOffAnimation();
        this.hasPreviewTelemetryBeenFired = false;
    };
    MotionShortcut.prototype.renderAnimationOptions = function () {
        var animationOption = this.props.blockStore.blockStyleStore.model.animation.animationOption;
        return (react_1.default.createElement("div", { className: "style-shortcut__section" },
            react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Animation Options"),
            react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                react_1.default.createElement(kaleidoscope_2.RadioButtonGroup, { options: animationOptions, selectedId: animationOption, onClickHandler: this.handleAnimationOptionChange }))));
    };
    MotionShortcut.prototype.renderAnimationType = function () {
        var _a = this.props.blockStore.blockStyleStore.model.animation, animationOption = _a.animationOption, animationType = _a.animationType;
        if (animationOption === commonTypes_1.AnimationOption.None) {
            return;
        }
        return (react_1.default.createElement("div", { className: "style-shortcut__section" },
            react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Type", size: kaleidoscope_1.SegmentedControlSize.Medium, options: animationTypeOptions, selectedValue: animationType, onClickHandler: this.handleAnimationTypeChange }))));
    };
    MotionShortcut.prototype.renderDirection = function () {
        var _a = this.props.blockStore.blockStyleStore.model.animation, animationOption = _a.animationOption, animationType = _a.animationType, direction = _a.direction;
        if (animationOption === commonTypes_1.AnimationOption.None || animationType === commonTypes_1.AnimationType.Fade) {
            return;
        }
        return (react_1.default.createElement("div", { className: "style-shortcut__section" },
            react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Direction", size: kaleidoscope_1.SegmentedControlSize.Medium, options: directionOptions, selectedValue: direction, onClickHandler: this.handleDirectionChange }))));
    };
    MotionShortcut.prototype.renderSpeed = function () {
        var _a = this.props.blockStore.blockStyleStore.model.animation, animationOption = _a.animationOption, speed = _a.speed;
        if (animationOption === commonTypes_1.AnimationOption.None) {
            return;
        }
        return (react_1.default.createElement("div", { className: "style-shortcut__section" },
            react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Speed", size: kaleidoscope_1.SegmentedControlSize.Medium, options: speedOptions, selectedValue: speed, onClickHandler: this.handleSpeedChange }))));
    };
    MotionShortcut.prototype.renderPreviewButton = function () {
        var animationOption = this.props.blockStore.blockStyleStore.model.animation.animationOption;
        if (animationOption === commonTypes_1.AnimationOption.None) {
            return;
        }
        return (react_1.default.createElement("div", { className: "style-shortcut__section" },
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, width: "full", size: kaleidoscope_1.ButtonSize.Small, onClick: this.handlePreviewClick }, "Preview")));
    };
    MotionShortcut = __decorate([
        mobx_react_1.observer
    ], MotionShortcut);
    return MotionShortcut;
}(react_1.default.Component));
var animationOptions = [
    {
        id: commonTypes_1.AnimationOption.None,
        label: "No animation",
    },
    {
        id: commonTypes_1.AnimationOption.Section,
        label: "Animate by section",
    },
    {
        id: commonTypes_1.AnimationOption.Together,
        label: "Animate together",
    },
];
var animationTypeOptions = [
    {
        label: "Fade in",
        value: commonTypes_1.AnimationType.Fade,
    },
    {
        label: "Slide in",
        value: commonTypes_1.AnimationType.Slide,
    },
];
var directionOptions = [
    {
        value: commonTypes_1.AnimationDirection.Left,
        label: react_1.default.createElement(icons_1.ArrowLeft, null),
    },
    {
        value: commonTypes_1.AnimationDirection.Right,
        label: react_1.default.createElement(icons_1.ArrowRight, null),
    },
    {
        value: commonTypes_1.AnimationDirection.Up,
        label: react_1.default.createElement(icons_1.ArrowUp, null),
    },
    {
        value: commonTypes_1.AnimationDirection.Down,
        label: react_1.default.createElement(icons_1.ArrowDown, null),
    },
];
var speedOptions = [
    {
        value: commonTypes_1.AnimationSpeed.Slow,
        label: "Slow",
    },
    {
        value: commonTypes_1.AnimationSpeed.Medium,
        label: "Med",
    },
    {
        value: commonTypes_1.AnimationSpeed.Fast,
        label: "Fast",
    },
];
exports.default = MotionShortcut;
